module.exports = __webpack_public_path__ + "img/tl.0616faaa.svg";